<template>
  <div>
    <div class="common-form" style="border-bottom: 1px solid #DCDFE6;">技师状况</div>
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline" >
        <el-form-item label="城市">
          <el-select size="small" v-model="searchForm.city_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in cityList" :key="index" :label="item.city" :value="item.city_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-radio-group v-model="searchForm.order_type" size="medium">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="today">今日</el-radio-button>
            <el-radio-button label='sevendays'>近七天</el-radio-button>
            <el-radio-button label='month'>近一个月</el-radio-button>
            <el-radio-button label='harf-year'>近半年</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="时间筛选">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.createTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item> -->
      </el-form>

    </div>
    <el-row type="flex" class="row-bg">
      <el-col v-for="(item, index) in personNum" :key="index" :span="6">
        <div class="f-b-c">
          <div>
            <span class="tubiao icon iconfont" :class="item.iconClass" :style="{ background: item.color}"></span>
          </div>
          <div class="word-box">
            <div>
              {{ item.label }}
              <el-tooltip class="item" v-if="item.showTooltip" effect="dark" :content="item.content" placement="top-start">
                <i class="el-tooltip icon iconfont icon-gantanhao gray item"></i>
              </el-tooltip>
            </div>
            <div :style="{ color: item.color, fontSize: '24px' }">{{ item.value }}人</div>
          </div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import StatisticsApi from "@/api/statistics.js";
export default {
  components: {},
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      searchForm: {
        city_id: "",
        order_type: "all",
        createTime: ""
      },
      cityList: [],
      personNum: [] // 人员数量
      // data1: [
      //   {
      //     label: "累计技师1",
      //     value: "1",
      //     iconClass: "icon-vip",
      //     color: "pink",
      //     content: "这是一个提示!",
      //     showTooltip: false
      //   },
      //   {
      //     label: "累计技师2",
      //     value: "1",
      //     iconClass: "icon-vip",
      //     color: "chocolate",
      //     showTooltip: true,
      //     content: "这是累计技师2的提示词"
      //   },
      //   {
      //     label: "累计技师3",
      //     value: "1",
      //     iconClass: "icon-vip",
      //     color: "orange",
      //     content: "这是一个提示!",
      //     showTooltip: false
      //   },
      //   {
      //     label: "累计技师4",
      //     value: "1",
      //     iconClass: "icon-vip",
      //     color: "#8378ea",
      //     content: "这是一个提示!",
      //     showTooltip: false
      //   },
      //   {
      //     label: "累计技师5",
      //     value: "1",
      //     iconClass: "icon-vip",
      //     color: "darkmagenta",
      //     content: "这是一个提示!",
      //     showTooltip: false
      //   },
      //   {
      //     label: "累计技师6",
      //     value: "1",
      //     iconClass: "icon-vip",
      //     color: "#37a5f3",
      //     showTooltip: true,
      //     content: "这是累计技师2的提示词"
      //   }
      // ]
    };
  },
  inject: ["dataModel"],
  mounted() {
    this.onSubmit();
  },
  methods: {
    onSubmit() {
      let self = this;
      let Params = self.searchForm;
      Params.order_type = self.searchForm.order_type;
      StatisticsApi.getHeader(Params, true)
        .then(res => {
          self.personNum = res.data.data;
          self.cityList = res.data.city;
          self.loading = false;
        })
        .catch(error => {});
    }
  }
};
</script>

<style scoped>
.row-bg {
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.flex-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.f-b-c {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}
.word-box {
  font-weight: 700;
  font-size: 16px;
  margin-left: 10px;
}
.tubiao {
  color: #fff;
  padding: 10px;
  width: 50px;
  color: #fff;
  background: #37a5f3;
  border-radius: 50%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 32px;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/technician/part/Total.vue